
import { BaseAppConfig } from 'lib-customizations/types'

import { env, Env } from './env'

type AppConfigs = {
  default: BaseAppConfig
} & {
  [k in Env]: BaseAppConfig
}

const employeeConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
}

const employeeMobileConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
}

const citizenConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://8ca615ada49e4c06af20f5bb514eabbb@sentry.haltu.net/45',
      enabled: true,
    },
  },
}

const employeeConfig = employeeConfigs[env()]
const employeeMobileConfig = employeeMobileConfigs[env()]
const citizenConfig = citizenConfigs[env()]

export { employeeConfig, employeeMobileConfig, citizenConfig }
